import axios from 'axios';
import { API_BASE } from './config';

const API_BASE_URL = `${API_BASE}/api`;

export const forgotPassword = async (email: string): Promise<void> => {
  await axios.post(`${API_BASE_URL}/Auth/forgot-password`, { email });
};

export const resetPassword = async (email: string, token: string, newPassword: string): Promise<void> => {
  await axios.post(`${API_BASE_URL}/Auth/reset-password`, { email, token, newPassword });
};

export const confirmEmail = async (token: string, email: string): Promise<void> => {
  await axios.get(`${API_BASE_URL}/Auth/confirm-email`, { params: { token, email } });
};

export const resendConfirmation = async (email: string): Promise<void> => {
  await axios.post(`${API_BASE_URL}/Auth/resend-confirmation`, { email });
};
